import React, { useRef, useEffect, useState } from "react";
import Chart from 'chart.js/auto';
import styled from "styled-components";
import axios from "axios";


const CustomerHealthSummary = () => {

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"


    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(true);

    const todayDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    const fetchChartData = async () => {
        try {
            const response = await axios.get(
                `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/MAIN/Customer_Health_Summary/2024-01-01/${todayDate}/-/-/-/-/-`
            );
            setChartData(response.data[0]);
            console.log("cust month >>", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const chartRef = useRef(null);

    let chart = useRef()

    useEffect(() => {

        fetchChartData();

    }, []);

    useEffect(() => {

        if (chartData) {

           

            const ctx = chartRef.current.getContext("2d");

            if (ctx) {
                if (chart.current) chart.current.destroy();
               
                chart.current = new Chart(ctx, {
                    type: "doughnut",
                    data: {
                        datasets: [
                          {
                            data: [chartData["Total Active Customers"],chartData["New Customers (6M)"],chartData["Inactive (3M)"],chartData["Reactivated (3M)"]],
                            backgroundColor: [
                            'rgb(75, 192, 192)',
                              'rgb(255, 99, 132)',
                              'rgb(255, 159, 64)',
                              'rgb(255, 205, 86)',
                            ],
                          },
                        ],
                        labels: ["Total Active Customers", 'New Customers (6M)', 'Inactive (3M)', 'Reactivated (3M)'],
                      },
                      
                });
            }
        }

    }, [chartData])

    return (
        <div style={{height:"300px"}}>

            

            <canvas ref={chartRef}>

            </canvas>
        </div>
    );
};

export default CustomerHealthSummary;
